import VBaseSelectContext from './context';
import type { VBaseSelectContextValue } from './type';

const useVBaseSelectContext = <M extends boolean = false>() =>
  VBaseSelectContext.hook() as VBaseSelectContextValue<M>;

export default useVBaseSelectContext;
